// Third Party
import * as $ from "jquery";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";

// Services
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js";

// Constants
import { FILE_TYPE } from "@/app/constants/type-constants.js";
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/constants.js";


const ACTION_TYPES = {
    UPLOAD: "Upload",
    EDIT: "Edit",
    DELETE: "Delete",
}

export default {
    name: "ModalAddEditDeleteDamSireDocument",
    mixins: [toastMessageMixins, userMixins],
    data() {
        return {
            ACTION_TYPES,
            actionType: "",
            damSireId: null,
            breederSysId: null,
            
            isAPILoading: false,
            isAPISubmitLoading: false,

            url: null,
            hasImage: false,
            description: "",
            initialDescription: "",
            fileName: null,
            document: null,
        };
    },
    created(){
		this.damSireId = this.$route.params.damSireId;
        this.breederSysId = this.$route.params.breederSysId;
    },
    beforeDestroy() {
        this.hideModal();
    },
    methods: {
        show(content, actionType) {
            if (!actionType) {
                return;
            }

            this.clearFields();
            this.actionType = actionType;
            this.document = content;

            if (actionType === ACTION_TYPES.UPLOAD) {
                this.url = this.fileFormat(content.type);
                this.fileName = content.name;

                // display document icon if the file type is pdf or docx
                if (!this.url) {
                    this.hasImage = true;
                    const fileReader = new FileReader();
                    fileReader.addEventListener("load", () => {
                        this.url = fileReader.result;
                    });
                    fileReader.readAsDataURL(content);
                }
            }

            if (actionType === ACTION_TYPES.EDIT){
                this.fileName = content.fileName;
                this.description = content.description;
                this.initialDescription = content.description;

                this.url = this.fileFormat(content.fileType);
                
                if(this.url === null){
                    this.hasImage = true;
                    this.url = content.fileURL;
                }
            }

            $(this.$refs.modalAddEditDeleteDamSireDocument).modal("show");
        },
        hideModal() {
            this.clearFields();
            $(this.$refs.modalAddEditDeleteDamSireDocument).modal("hide");
        },
        refreshTable() {
            this.hideModal();
            this.$emit("getTableContent");
        },
        clearFields() {
            this.url = null;
            this.hasImage = false;
            this.description = "";
            this.initialDescription = "";
            this.fileName = null;
            this.document = null;
            this.isAPILoading = false;
        },
        fileFormat(type) {
            const fileTypeImages = {
                [FILE_TYPE.DOC]: require("@/assets/images/file-type/word.svg"),
                [FILE_TYPE.PDF]: require("@/assets/images/file-type/pdf.svg"),
            };

            return fileTypeImages[type] || null;
        },
        fileType(type) {
            const fileTypeExtensions = {
                ["docx"]: require("@/assets/images/file-type/word.svg"),
                ["pdf"]: require("@/assets/images/file-type/word.svg"),
            };

            return fileTypeExtensions[type] || null;
        },
        async uploadDocument() {
            try{
                this.isAPISubmitLoading = true;

                const uploadDetails = {
                    formData: {
                        damSireId: this.damSireId,
                        description: this.description ? this.description.trim() : this.description,
                    },
                    document: this.document,
                };

                const response = await breedingManagementService.uploadDamSireDocument(this.breederSysId, uploadDetails);

                const { SUCCESS_ADD_DAM_SIRE_DOCUMENT, ERROR_ADD_DAM_SIRE_DOCUMENT } = this.toastMessages.damSireDocument();

                if (response.status === STATUS_CODES.SUCCESS_POST) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADD_DAM_SIRE_DOCUMENT);

                } else {
                    this.showAPIErrorToast(ERROR_ADD_DAM_SIRE_DOCUMENT, response);
                }
                
                this.refreshTable();
            } catch(err){
                this.showGenericErrorToast();
            } finally{
                this.isAPISubmitLoading = false;
            }
        },
        async updateDocument() {
            try{
                this.isAPISubmitLoading = true;

                const documentId = this.document.id;
                const updateDetails = {
                    description: this.description ? this.description.trim() : this.description,
                };

                const response = await breedingManagementService.updateDamSireDocument(documentId, updateDetails);

                const { SUCCESS_EDIT_DAM_SIRE_DOCUMENT, ERROR_EDIT_DAM_SIRE_DOCUMENT } = this.toastMessages.damSireDocument();

                if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_EDIT_DAM_SIRE_DOCUMENT);
                } else {
                    this.showAPIErrorToast(ERROR_EDIT_DAM_SIRE_DOCUMENT, response);
                }
                
                this.refreshTable();
            } catch(err){
                this.showGenericErrorToast();
            } finally{
                this.isAPISubmitLoading = false;
            }
        },
    },
};
